import gql from "graphql-tag";

export const GET_SIGNED_URL = gql`
  mutation signedURL($fileName: String!, $value: VALUE!, $type: TYPE!) {
    signedURL(input: { fileName: $fileName, value: $value, type: $type }) {
      url
    }
  }
`;
